import { GuardPermission } from '@/models/auth/GuardPermission';
import { UserAuth, UserJsonParse } from '@/models/auth/UserAuth';
import { jwtDecode } from 'jwt-decode';

export function getUserAuthByToken(token: string): UserAuth | undefined {
  const payload = jwtDecode<UserJsonParse>(token);

  if (!payload) {
    return;
  }
  return {
    userId: payload.sub,
    aud: payload.aud,
    iss: payload.iss,
    roles: payload.roleId,
  };
}

/**
 * Check user permissions contain the require permission.
 * @param requirePermission require permission, ex: "read:user", "create:product", "*:campaign",....
 * @param userPermissions user's permissions, ex: ["read:user", "create:user", "*:product", "read:*", "*:*"]
 */
export function checkPermissionExists(
  requirePermission: string,
  userPermissions: string[],
): boolean {
  const requireItems = requirePermission.split(':');
  if (requireItems.length !== 2) {
    return false;
  }

  return userPermissions.some(userPermission => {
    if (userPermission === '*:*' || userPermission === requirePermission) {
      return true;
    }
    const userItems = userPermission.split(':');
    if (userItems.length !== 2) {
      return false;
    }
    if (
      (userItems[0] === '*' && userItems[1] === requireItems[1]) ||
      (userItems[1] === '*' && userItems[0] === requireItems[0])
    ) {
      return true;
    }
    return false;
  });
}

export function checkGuardAllowAccess(
  auth?: UserAuth,
  permissions?: GuardPermission | GuardPermission[],
) {
  if (!auth) {
    return false;
  }
  if (!permissions || (Array.isArray(permissions) && !permissions.length)) {
    return true;
  }

  const list = Array.isArray(permissions) ? permissions : [permissions];
  return list.some(permission => {
    if (
      permission.userTypes?.length &&
      !permission.userTypes.includes(auth.roles)
    ) {
      return false;
    }

    if (
      permission.roleCodes?.length &&
      !permission.roleCodes.some(roleCode => auth.roles?.length && auth.roles)
    ) {
      return false;
    }

    if (
      permission.excludeRoleCodes?.length &&
      permission.excludeRoleCodes.some(
        roleCode => auth.roles?.length && auth.roles,
      )
    ) {
      return false;
    }

    if (permission.actions?.length) {
      return false;
    }
    return true;
  });
}
